/**
 * Комментарии к существенным отклонениям план/факт (Р-13). Backend отбирает
 * факты с |отклонением| ≥ порога и генерирует к каждому деловой LLM-комментарий
 * (summary.deviation_comments). Раньше этот текст сохранялся в БД, но нигде не
 * показывался — здесь выводим его в карточке обработки понятным списком.
 */
import styled from 'styled-components';
import type { DeviationComment } from '@entities/economic/types';
import { labelMetric } from '@entities/economic/types';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

const Item = styled.li`
  border-left: 3px solid ${({ theme }) => theme.colors.primary};
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(3)}`};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const Head = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-wrap: wrap;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

const Metric = styled.span`
  font-weight: 650;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const Text = styled.p`
  margin: 0;
  font-size: 13.5px;
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export function DeviationComments({ comments }: { comments: DeviationComment[] }) {
  if (comments.length === 0) return null;
  return (
    <List>
      {comments.map((c, i) => (
        <Item key={`${c.metric}-${c.object}-${i}`}>
          <Head>
            {c.metric && <Metric>{labelMetric(c.metric)}</Metric>}
            {c.object && <span>· {c.object}</span>}
          </Head>
          <Text>{c.comment}</Text>
        </Item>
      ))}
    </List>
  );
}
